/* eslint-disable import/prefer-default-export */
import startsWith from 'lodash/fp/startsWith';

export const generateColumnTableExcel = ({ key, value }: { key: string; value: any }) => {
  if (startsWith('_', key)) {
    return {
      name: key,
      type: 'hidden',
    };
  }
  return {
    name: key,
    title: key,
    width: 200,
    type: 'text',
  };
};
